import Swal from "sweetalert2";
import { const_routes } from "../helpers/const_routes";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { startLogout } from "./authActions";
import { t } from "i18next";
import { debugErrorActions, debugLogActions } from "../helpers/debugHelper";

export const startLoadingCatalogModules = () => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGMODULE}`, "get");
    const body = await resp.json();

    debugLogActions(':: catalogModuleActions, startLoadingCatalogModules', { 'body': body });

    if (body.ok) {
      
      dispatch(loadingCatalogModules(body.catalogModules));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingCatalogModules = (catalogModules) => ({
  type: types.CATALOGMODULE_START_LOADING,
  payload: catalogModules,
});

export const startLoadingCatalogModulesPaginated = (page, size) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGMODULE}`, `get/${page}/${size}`);
    const body = await resp.json();

     debugLogActions(':: catalogModuleActions, startLoadingCatalogModulesPaginated', { 'body': body });

    if (body.ok) {
      
      dispatch(loadingCatalogModulesPaginated(body.catalogModulePaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingCatalogModulesPaginated = (catalogModulePaginated) => ({
  type: types.CATALOGMODULE_START_LOADING_PAGINATED,
  payload: catalogModulePaginated,
});

export const selectCatalogModules = (catalogModule) => ({
  type: types.CATALOGMODULE_SELECT,
  payload: catalogModule,
});

export const catalogModuleClean = () => ({
  type: types.CATALOGMODULE_CLEAN,
});

export const catalogModuleStartDelete = (id) => {
  return async (dispatch) => {
    try {
      await Swal.fire({
        title: t("record_delete.title"),
        text: t("record_delete.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("titles.delete"),
      }).then((result) => {
        if (result.isConfirmed) {
          fetchToken(
            `${const_routes.SCHEMA}`,
            `${const_routes.VERSIONV1}`,
            `${const_routes.ROUTE_CATALOGMODULE}`,
            `delete/${id}`,
            { deleted: false },
            "DELETE"
          )
            .then((resp) => resp.json())
            .then((body) => {

               debugLogActions(':: catalogModuleActions, catalogModuleStartDelete', { 'body': body });

              if (body.ok) {
                dispatch(catalogModuleDeleted(id));
              } else {
                if (body.code === "bak-error-001") {
                   Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
                  
                }
                if (body.code === "bak-aut-tok-inv-001") {
                  Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
                  dispatch(startLogout());
                }
                if (body.code === "bak-aut-tok-inv-002") {
                  Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
                  dispatch(startLogout());
                }
              }
            });
          Swal.fire(t("titles.success"), t("record.delete"), "success");
        }
      });
    } catch (error) {
      debugErrorActions(':: catalogModuleActions, catalogModuleStartDelete', { 'error': error });
    }
  };
};

const catalogModuleDeleted = (id) => {
  return {
    type: types.CATALOGMODULE_DELETE,
    payload: id,
  };
};

export const startSearchingCatalogModulePaginated = (textSearch, page, size) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_CATALOGMODULE}`,
      `search/${textSearch}/${page}/${size}`
    );
    const body = await resp.json();

     debugLogActions(':: catalogModuleActions, startSearchingCatalogModulePaginated', { 'body': body });

    if (body.ok) {
      dispatch(searchingCatalogModulesPaginated(body.catalogModulesPaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const searchingCatalogModulesPaginated = (catalogModulesPaginated) => ({
  type: types.CATALOGMODULE_START_SEARCH_PAGINATED,
  payload: catalogModulesPaginated,
});

export const cleanSearchingCatalogModulesPaginated = () => ({
  type: types.CATALOGMODULE_CLEAN_SEARCH_PAGINATED,
});

export const catalogModuleStartUpdate = (catalogModule, navigate) => {
  return async (dispatch) => {
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_CATALOGMODULE}`,
        `update/${catalogModule.id}`,
        catalogModule,
        "PUT"
      );
      const body = await resp.json();

       debugLogActions(':: catalogModuleActions, catalogModuleStartUpdate', { 'body': body });

      if (body.ok) {
        dispatch(catalogModuleUpdated(catalogModule));

        Swal.fire({
          title: t("titles.success"),
          text: t("record.update"),
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: t("buttons.close")
        }).then((result) => {
          if (result.isConfirmed) {
            setTimeout(() => {
              navigate("/admin-catalog-module");
            }, 5000);
          }
        });

      } else {
        if (body.code === "bak-error-001") {
           Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
          
        }
        if (body.code === "bak-aut-tok-inv-001") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-001"), "error");
          dispatch(startLogout());
        }
        if (body.code === "bak-aut-tok-inv-002") {
          Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
          dispatch(startLogout());
        }
      }
    } catch (error) {
      debugErrorActions(':: catalogModuleActions, catalogModuleStartUpdate', { 'error': error });
    }
  };
};

/**
 * Funcion para actualizar un evento en el store
 * @param {*} catalogModule
 * @returns
 */
const catalogModuleUpdated = (catalogModule) => {
  return {
    type: types.CATALOGMODULE_UPDATE,
    payload: catalogModule,
  };
};

export const catalogModuleStartRegister = (catalogModule, navigate) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_CATALOGMODULE}`,
      "add",
      catalogModule,
      "POST"
    );

    const body = await resp.json();

     debugLogActions(':: catalogModuleActions, catalogModuleStartRegister', { 'body': body });

    if (body.ok) {
      dispatch(catalogModuleRegister(body.catalogModule));

      Swal.fire({
        title: t("titles.success"),
        text: t("record.save"),
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: t("buttons.close")
      }).then((result) => {
        if (result.isConfirmed) {
          setTimeout(() => {
            navigate("/admin-catalog-module");
          }, 5000);
        }
      });

    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const catalogModuleRegister = (catalogModule) => ({
  type: types.CATALOGMODULE_START_REGISTER,
  payload: catalogModule,
});

export const catalogModuleSetSearchText = (searchText) => ({
  type: types.CATALOGMODULE_SET_SEARCH_TEXT,
  payload: searchText,
});

export const catalogModuleCleanSearchText = () => ({
  type: types.CATALOGMODULE_SET_SEARCH_TEXT,
});
